import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

const container = document.querySelector('.js-animated-rows');
const containerWidth = container.clientWidth;

const firstRow = container.querySelector('.js-first-row');
const secondRow = container.querySelector('.js-second-row');

const templateFirstRow = firstRow.querySelector('.js-template');
const templateSecondRow = secondRow.querySelector('.js-template');

const countOfClone1 = Math.max((Math.ceil(containerWidth / firstRow.children[0].offsetWidth) - 1) * 2, 2);
for (let i = 0; i < countOfClone1; i++) {
  const clone = templateFirstRow.cloneNode(true);
  firstRow.append(clone);
}
const countOfClone2 = Math.max((Math.ceil(containerWidth / secondRow.children[0].offsetWidth) - 1) * 2, 2);
for (let i = 0; i < countOfClone2; i++) {
  const clone = templateSecondRow.cloneNode(true);
  secondRow.append(clone);
}

// $('#el').focus((e) => {
//   e.preventDefault();
//   e.target.focus({preventScroll: true});
// })

// [...container.querySelectorAll('a')].forEach(a => { 
//   // console.log(a);
//   a.focus({ preventScroll: true });
//   a.addEventListener('focus', e => {
//     e.preventDefault();
//     // e.stopPropagation();
//     // e.target.blur();
//     e.target.focus({preventScroll: true})
//     // e.target.blur();
//   }, true)
// })

const windowOffset = Math.max(window.innerWidth / 5, 300);
const widthInProcentForRow1 = 100 * windowOffset / firstRow.offsetWidth;
const widthInProcentForRow2 = 100 * windowOffset / secondRow.offsetWidth;

gsap.timeline({
  scrollTrigger: {
    trigger: container,
    start: "top bottom",
    end: "bottom top",
    scrub: true,
    // markers: true,
    scroller: '[data-scroll-container]',
  }
})
.to(firstRow, {xPercent: widthInProcentForRow1}, 0)
.to(secondRow, {xPercent: -widthInProcentForRow2}, 0);

ScrollTrigger.refresh();